import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useEffect, useState } from 'react';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

interface CalendarViewProps {
	value: Value;
	onChange: (newValue: Value) => void;
	activeStartDate: Date;
	onActiveStartDateChange: (date: { activeStartDate: Date }) => void;
	events: Event[];
	onEventClick: (event: Event) => void;
}

interface Event {
	id: number;
	title: string;
	date: string;
	description: string;
	images: { [key: string]: string };
}

function CalendarView({ value, onChange, activeStartDate, onActiveStartDateChange, events, onEventClick }: CalendarViewProps) {
	const [selectedDate, setSelectedDate] = useState<Date>(new Date());
	const [isMobileView, setIsMobileView] = useState<boolean>(window.innerWidth < 1024);

	useEffect(() => {
		const handleResize = () => setIsMobileView(window.innerWidth < 1024);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		console.log('All events:', events);
	}, [events]);

	const handleDateClick = (date: Date) => {
		console.log('Clicked day:', date);
		setSelectedDate(date);
	};

	const tileContent = ({ date, view }: { date: Date; view: string }) => {
		if (view === 'month') {
			const eventDate = events.filter(event => new Date(event.date).toDateString() === date.toDateString());

			if (eventDate.length > 0) {
				return (
					<div
						className={'react-calendar__tile__content'}
						style={{ cursor: 'pointer' }}
					>
						{eventDate.slice(0, isMobileView ? 1 : eventDate.length).map(event => (
							<div key={event.id} onClick={() => !isMobileView && onEventClick(event)}>
								<span>{event.title}</span>
							</div>
						))}
					</div>
				);
			}
		}
		return null;
	};

	const eventsOnSelectedDate = events.filter(event => new Date(event.date).toDateString() === selectedDate.toDateString());

	return (
		<div
			style={{
				display:'flex',
				flexDirection:'column'
			}}
		>
			<Calendar
				onChange={onChange}
				onClickDay={handleDateClick}
				value={value}
				tileContent={tileContent}
				view="month"
				locale="en-EN"
				activeStartDate={activeStartDate}
				onActiveStartDateChange={onActiveStartDateChange}
			/>
			{isMobileView && ( // Only render this section if it's mobile view
				<div>
					<h3>Events on {selectedDate.toDateString()}:</h3>
					{eventsOnSelectedDate.length > 0 ? (
						<ul>
							{eventsOnSelectedDate.map(event => (
								<li key={event.id}>
									<h4>{event.title}</h4>
									<p>{event.description}</p>
									{/* Optionally render images or other event details here */}
								</li>
							))}
						</ul>
					) : (
						<p>No events</p>
					)}
				</div>
			)}
		</div>
	);
}

export default CalendarView;
